import React from "react";
import { Redirect } from "react-router-dom";
import useUser from "../../hooks/useUser";
import LoginFooter from "../login/components/LoginFooter";
import SignupForm from "./components/SignupForm";
import style from "./Signup.module.scss";
import config from "../../config";

const SIGNUP_IFRAME_URL =
  config.signupIframeUrl || "https://www.chaserhq.com/chaser-login-page-iframe";

const Signup = () => {
  const { isLoggedIn } = useUser();

  // TODO: Redirect to /home
  if (isLoggedIn) {
    return (
      <Redirect
        to={{
          pathname: "/receivables/dashboard",
        }}
      />
    );
  }

  return (
    <div className={style.signupPage}>
      <div className={style.signupMain}>
        <div className={style.signupLeft}>
          <iframe
            src={SIGNUP_IFRAME_URL}
            className={style.marketingIframe}
            title="Chaser free trial benefits"
            frameBorder="0"
            scrolling="no"
          />
        </div>
        <div className={style.signupRight}>
          <SignupForm />
        </div>
      </div>
      <div className={style.signupFooter}>
        <LoginFooter />
      </div>
    </div>
  );
};

export default Signup;
